import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { rainOutlook, ALERT_STATES, WX_STORE, WX_EVENT, todayIso } from "@/lib/weather";

const REFRESH_MS = 5 * 60 * 1000;

async function currentPlace() {
  let choice = { mode: "auto" };
  try { choice = JSON.parse(localStorage.getItem(WX_STORE)) || choice; } catch { /* default */ }
  if (choice.mode !== "auto") return choice;
  const { data } = await api.get("/weather/places", { params: { today: todayIso() } });
  return data.live?.[0] || null;
}

export function useWeatherStatus(lang) {
  const [status, setStatus] = useState(null);
  const [, tick] = useState(0);
  useEffect(() => {
    let alive = true;
    const run = async () => {
      try {
        const place = await currentPlace();
        if (!place) { if (alive) setStatus(null); return; }
        const { data } = await api.get("/weather", { params: { lat: place.lat, lon: place.lon, lang } });
        if (alive) setStatus({ data, place: place.name });
      } catch { if (alive) setStatus(null); }
    };
    run();
    const id = setInterval(run, REFRESH_MS);
    const tk = setInterval(() => tick((n) => n + 1), 30000);
    window.addEventListener(WX_EVENT, run);
    return () => { alive = false; clearInterval(id); clearInterval(tk); window.removeEventListener(WX_EVENT, run); };
  }, [lang]);
  if (!status) return null;
  const now = Date.now() / 1000;
  const rain = rainOutlook(status.data.minutely, status.data.hourly);
  const alerts = (status.data.alerts || []).filter((a) => !a.end || a.end > now).length;
  return { ...status, rain: ALERT_STATES.includes(rain?.state) ? rain : null, alerts };
}
